export default __webpack_public_path__ + "static/media/amanda.4c927849.jpg";